import React from 'react';
import PropTypes from 'prop-types';
import { Container } from './styles';

const CommunityLayout = ({ children }) => {
    return <Container>{children}</Container>;
};

CommunityLayout.propTypes = {
    children: PropTypes.node.isRequired
};

export default CommunityLayout;
